import { Controller } from '@hotwired/stimulus';
import { patch } from '@rails/request.js';
import CurrentPage from '@frontend/app/features/CurrentPage';
import Plausible from 'plausible-tracker';

export default class extends Controller {
  connect() {
    const goals = window.ENV.userGoals.filter(
      (goal) => goal.system == 'plausible'
    );
    if (goals.length === 0) return;

    const { trackEvent } = Plausible({ trackLocalhost: false });
    goals.forEach((goal) => {
      trackEvent('Subscription Created', {
        callback: () => this.markGoalProcessed(goal.id),
      });
    });
  }

  markGoalProcessed(goalId) {
    patch(
      CurrentPage.getUserGoalMarkTrackedActionPath().replace(
        ':user_goal_id',
        goalId
      )
    );
  }
}
